import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
export const reviewPipelineNavEntry = {
    id: 'rp',
    prefix: 'RP_',
    to: { screen: 'RP_Home', params: {} },
    label: ({ translate }) => translate('Review Pipeline'),
    renderIcon: (color, size) => (React.createElement(FeatherIcon, { name: "check-circle", color: color, size: size })),
    badge: ({ rpPendingCount }) => rpPendingCount,
    isVisible: ({ isSuperAdmin }) => isSuperAdmin,
    placements: ['sidebar-main'],
};
